// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetServerHelpInfoQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
}>;

export type GetServerHelpInfoQuery = {
  __typename?: "GraphqlQuery";
  getServerDetails: {
    __typename?: "Server";
    id: string;
    systemType?: string | null;
    collectorInfo?: {
      __typename?: "CollectorInfo";
      id: string;
      configFromEnv: boolean;
      monitoringUser?: string | null;
    } | null;
    lastSnapshot?: {
      __typename?: "Snapshot";
      collectorVersionStr: string;
    } | null;
  };
};

export const GetServerHelpInfoDocument = gql`
  query GetServerHelpInfo($serverId: ID!) {
    getServerDetails(serverId: $serverId) {
      id
      systemType
      collectorInfo {
        id
        configFromEnv
        monitoringUser
      }
      lastSnapshot {
        collectorVersionStr
      }
    }
  }
`;

/**
 * __useGetServerHelpInfoQuery__
 *
 * To run a query within a React component, call `useGetServerHelpInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServerHelpInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServerHelpInfoQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *   },
 * });
 */
export function useGetServerHelpInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetServerHelpInfoQuery,
    GetServerHelpInfoQueryVariables
  > &
    (
      | { variables: GetServerHelpInfoQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetServerHelpInfoQuery,
    GetServerHelpInfoQueryVariables
  >(GetServerHelpInfoDocument, options);
}
export function useGetServerHelpInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetServerHelpInfoQuery,
    GetServerHelpInfoQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetServerHelpInfoQuery,
    GetServerHelpInfoQueryVariables
  >(GetServerHelpInfoDocument, options);
}
// @ts-ignore
export function useGetServerHelpInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetServerHelpInfoQuery,
    GetServerHelpInfoQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetServerHelpInfoQuery,
  GetServerHelpInfoQueryVariables
>;
export function useGetServerHelpInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetServerHelpInfoQuery,
        GetServerHelpInfoQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetServerHelpInfoQuery | undefined,
  GetServerHelpInfoQueryVariables
>;
export function useGetServerHelpInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetServerHelpInfoQuery,
        GetServerHelpInfoQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetServerHelpInfoQuery,
    GetServerHelpInfoQueryVariables
  >(GetServerHelpInfoDocument, options);
}
export type GetServerHelpInfoQueryHookResult = ReturnType<
  typeof useGetServerHelpInfoQuery
>;
export type GetServerHelpInfoLazyQueryHookResult = ReturnType<
  typeof useGetServerHelpInfoLazyQuery
>;
export type GetServerHelpInfoSuspenseQueryHookResult = ReturnType<
  typeof useGetServerHelpInfoSuspenseQuery
>;
export type GetServerHelpInfoQueryResult = Apollo.QueryResult<
  GetServerHelpInfoQuery,
  GetServerHelpInfoQueryVariables
>;
